import { registerBlockType } from '@wordpress/blocks';
import { edit } from './handlers.ts';
import metadata from './block.json';

registerBlockType( metadata, {
       edit,
       save: () => ''
});